"use client";

import { loading } from "@/lib/features/hotel/hotelSlice";
import { useAppSelector } from "@/lib/hooks";
import { useCallback, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css"; // Import skeleton CSS

interface FilterProps {
  onChange: (value: string[]) => void;
  data: { label: string; value: string }[];
  value: string[];
}

const PropertyTypeFilter = ({ onChange, data, value }: FilterProps) => {
  const isLoading = useAppSelector(loading);

  const handleCheckboxChange = useCallback(
    (checkboxValue: string) => {
      // Ensure the value is in the correct format (string or number based on your data)
      const numericValue = checkboxValue; // Modify this if your values need different formatting

      // Check if value is already selected
      const isSelected = value?.includes(numericValue);

      // Create new array based on whether we're adding or removing the value
      const newValues = isSelected
        ? value.filter((val: string) => val !== numericValue)
        : [...(value || []), numericValue];

      // Call parent's onChange with updated values
      onChange(newValues);
    },
    [value, onChange]
  );

  return (
    <>
      {/* {JSON.stringify(selectedValues)} */}
      {isLoading
        ? // Skeleton loader when isLoading is true
          Array(6)
            .fill(0)
            .map((_, index) => (
              <div className="col-12 mb-2" key={index}>
                <div className="form-checkbox d-flex items-center">
                  <input name="amenities" type="checkbox" disabled={true} />
                  <div className="form-checkbox__mark">
                    <div className="form-checkbox__icon icon-check" />
                  </div>
                  <div className="text-15 ml-10">
                    <Skeleton width={250} height={15} />
                  </div>
                </div>
              </div>
            ))
        : data?.map((item: any, index: number) => (
            <div className="col-12" key={index}>
              <div className="form-checkbox d-flex items-center">
                <input
                  name="property_type"
                  type="checkbox"
                  value={item?.value}
                  checked={value?.includes(item?.value) || false} // Use value prop from parent
                  onChange={(e) => handleCheckboxChange(e.target.value)}
                  disabled={isLoading}
                />

                <div className="form-checkbox__mark">
                  <div className="form-checkbox__icon icon-check" />
                </div>
                <div className="text-15 ml-10">{item.label}</div>
              </div>
            </div>
          ))}
    </>
  );
};

export default PropertyTypeFilter;
